// Root of the Conversation Viewer feature. Two routes mount under here:
//
//   /conversations           → ConversationListPage (rail visible, detail empty)
//   /conversations/:id       → ConversationListPage + ConversationDetailPage
//
// Layout is a fixed two-pane grid (rail + detail). The list rail stays
// mounted across selection changes so we don't re-fetch on every click.

import { useParams } from "react-router-dom";
import { ConversationListPage } from "./ConversationListPage";
import { ConversationDetailPage } from "./ConversationDetailPage";
import "./conversation.css";

export function ConversationViewer(): React.ReactElement {
  const { id } = useParams<{ id?: string }>();
  return (
    <div className="cv-viewer">
      <div className="cv-rail">
        <ConversationListPage selectedId={id ?? null} />
      </div>
      <div className="cv-detail">
        {id ? (
          <ConversationDetailPage id={id} />
        ) : (
          <div className="cv-detail-empty">Select a conversation</div>
        )}
      </div>
    </div>
  );
}

export default ConversationViewer;
